// extracted by mini-css-extract-plugin
module.exports = {"nav-wrapper":"MenuStub_nav-wrapper__ELnPf","menu-stub":"MenuStub_menu-stub__fMIB_","menu-stub__item":"MenuStub_menu-stub__item__4woTs"};